module.exports = __webpack_public_path__ + "static/media/5.11.3680f72a.png";